import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const NEW_DAY = { date: '', type: 'closed', start: '09:00', end: '13:00', reason: '', yearly: false };

export const SpecialDaysEditor = ({ value = [], onChange, disabled }) => {
  const update = (i, patch) => onChange(value.map((d, j) => (j === i ? { ...d, ...patch } : d)));
  const remove = (i) => onChange(value.filter((_, j) => j !== i));

  return (
    <div className="space-y-2" data-testid="wa-special-days">
      <div className="text-xs font-medium">Días especiales (feriados, vigilias, cierres)</div>
      {value.length === 0 && <div className="text-[11px] text-[hsl(var(--muted-foreground))]">No hay días especiales.</div>}
      {value.map((d, i) => (
        <div key={i} className="flex flex-wrap items-center gap-2 p-2 rounded-md border border-border" data-testid={`wa-special-row-${i}`}>
          <Input type="date" className="w-40 h-8 text-xs" disabled={disabled} value={d.date} onChange={(e) => update(i, { date: e.target.value })} data-testid={`wa-special-date-${i}`} />
          <Select value={d.type} disabled={disabled} onValueChange={(v) => update(i, { type: v })}>
            <SelectTrigger className="w-44 h-8 text-xs" data-testid={`wa-special-type-${i}`}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="closed">Cerrado todo el día</SelectItem>
              <SelectItem value="custom">Horario especial</SelectItem>
            </SelectContent>
          </Select>
          {d.type === 'custom' && (
            <>
              <Input type="time" className="w-28 h-8 text-xs" disabled={disabled} value={d.start || ''} onChange={(e) => update(i, { start: e.target.value })} data-testid={`wa-special-start-${i}`} />
              <Input type="time" className="w-28 h-8 text-xs" disabled={disabled} value={d.end || ''} onChange={(e) => update(i, { end: e.target.value })} data-testid={`wa-special-end-${i}`} />
            </>
          )}
          <Input placeholder="Motivo (ej. Vigilia nacional)" className="flex-1 min-w-[160px] h-8 text-xs" disabled={disabled} value={d.reason} onChange={(e) => update(i, { reason: e.target.value })} data-testid={`wa-special-reason-${i}`} />
          <label className="flex items-center gap-1.5 text-xs">
            <Checkbox checked={!!d.yearly} disabled={disabled} onCheckedChange={(v) => update(i, { yearly: !!v })} data-testid={`wa-special-yearly-${i}`} />Repetir cada año
          </label>
          <Button type="button" size="icon" variant="ghost" disabled={disabled} onClick={() => remove(i)} data-testid={`wa-special-remove-${i}`}><Trash2 className="h-4 w-4 text-red-300" /></Button>
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" disabled={disabled} onClick={() => onChange([...value, { ...NEW_DAY }])} data-testid="wa-special-add">
        <Plus className="h-4 w-4 mr-1" />Agregar día especial
      </Button>
    </div>
  );
};
